import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reject-form',
  templateUrl: './reject-form.component.html',
  styleUrls: ['./reject-form.component.scss']
})
export class RejectFormComponent {
  @Input() selection: any;
  @Input() pending: any;
  message: string='';

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal
  ) { }

  onSubmit(): void {
    alert('Thanks!');
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  confirmRejection() {
    this.activeModal.close({selection: this.selection, message: this.message});
  }
}
